{
  "intl-msg:error.commonError": "An error (module user settings) has occurred.\nWe apologise for the inconvenience and request that you try again later or contact the RIO Customer Care Hotline on 00800 – 22 55 07 46.",
  "intl-msg:inputFields.error.notEmpty": "The field must not be left blank.",
  "intl-msg:maintenanceMode": "We are currently performing maintenance. Only read access is available.",
  "intl-msg:minimalSettingsDialog.header": "User info",
  "intl-msg:minimalSettingsDialog.label.first_name": "First name",
  "intl-msg:minimalSettingsDialog.label.last_name": "Last name",
  "intl-msg:minimalSettingsDialog.label.logistics_tenant": "Logistics tenant",
  "intl-msg:minimalSettingsDialog.label.name": "Name",
  "intl-msg:minimalSettingsDialog.label.subject": "Subject",
  "intl-msg:minimalSettingsDialog.label.username": "Username",
  "intl-msg:minimalSettingsDialog.label.user_pool": "User pool",
  "intl-msg:popover.link.profile": "Profile & settings",
  "intl-msg:popover.link.switchAccount": "Switch account",
  "intl-msg:popover.logout": "Logout",
  "intl-msg:popover.title": "My account",
  "intl-msg:popover.userInfoUnknown": "User information retrieval unsuccessful.",
  "intl-msg:settingsDialog.accountInfo.copyNotice": "Copied account info to clipboard",
  "intl-msg:settingsDialog.accountInfo.tooltip": "Copy fleet info to clipboard",
  "intl-msg:settingsDialog.button.close.label": "Close",
  "intl-msg:settingsDialog.tab.accounts.buttonLabel": "Switch fleet",
  "intl-msg:settingsDialog.tab.accounts.error.switchAccount": "Could not switch fleet. Please try again later.",
  "intl-msg:settingsDialog.tab.accounts.label": "Fleets",
  "intl-msg:settingsDialog.tab.accounts.label.prompt": "select to switch",
  "intl-msg:settingsDialog.tab.accounts.search.placeholder": "Find fleet",
  "intl-msg:settingsDialog.tab.cookies.click.prompt": "click here",
  "intl-msg:settingsDialog.tab.cookies.headline": "Cookie Settings",
  "intl-msg:settingsDialog.tab.cookies.text": "For details on cookies and data protection, or to revoke your given consent to cookies",
  "intl-msg:settingsDialog.tab.language.button.save.label": "Save changes",
  "intl-msg:settingsDialog.tab.language.error.backend.fetchLocale": "Error while fetching your locale. Please try again later.",
  "intl-msg:settingsDialog.tab.language.error.backend.unknown": "An unknown error has occurred. Please try again later.",
  "intl-msg:settingsDialog.tab.language.headline": "Language",
  "intl-msg:settingsDialog.tab.language.label.language": "Language",
  "intl-msg:settingsDialog.tab.language.locale.bg-BG": "🇧🇬 български",
  "intl-msg:settingsDialog.tab.language.locale.cs-CZ": "🇨🇿 Čeština",
  "intl-msg:settingsDialog.tab.language.locale.da-DK": "🇩🇰 Dansk",
  "intl-msg:settingsDialog.tab.language.locale.de-DE": "🇩🇪 Deutsch",
  "intl-msg:settingsDialog.tab.language.locale.el-GR": "🇬🇷 Ελληνικά",
  "intl-msg:settingsDialog.tab.language.locale.en-GB": "🇬🇧 English",
  "intl-msg:settingsDialog.tab.language.locale.es-ES": "🇪🇸 Español",
  "intl-msg:settingsDialog.tab.language.locale.et-EE": "🇪🇪 Eesti",
  "intl-msg:settingsDialog.tab.language.locale.fi-FI": "🇫🇮 Suomalainen",
  "intl-msg:settingsDialog.tab.language.locale.fr-FR": "🇫🇷 Français",
  "intl-msg:settingsDialog.tab.language.locale.hr-HR": "🇭🇷 Hrvatski",
  "intl-msg:settingsDialog.tab.language.locale.hu-HU": "🇭🇺 Magyar",
  "intl-msg:settingsDialog.tab.language.locale.it-IT": "🇮🇹 Italiano",
  "intl-msg:settingsDialog.tab.language.locale.ko-KR": "🇰🇷 한국어",
  "intl-msg:settingsDialog.tab.language.locale.lt-LT": "🇱🇹 Lietuvių",
  "intl-msg:settingsDialog.tab.language.locale.lv-LV": "🇱🇻 Latviešu",
  "intl-msg:settingsDialog.tab.language.locale.nb-NO": "🇳🇴 Bokmål",
  "intl-msg:settingsDialog.tab.language.locale.nl-NL": "🇳🇱 Nederlands",
  "intl-msg:settingsDialog.tab.language.locale.no-NO": "🇳🇴 Norsk",
  "intl-msg:settingsDialog.tab.language.locale.pl-PL": "🇵🇱 Polski",
  "intl-msg:settingsDialog.tab.language.locale.pt-BR": "🇧🇷 Português",
  "intl-msg:settingsDialog.tab.language.locale.pt-PT": "🇵🇹 Portugues",
  "intl-msg:settingsDialog.tab.language.locale.ro-RO": "🇷🇴 Română",
  "intl-msg:settingsDialog.tab.language.locale.sk-SK": "🇸🇰 Slovenčina",
  "intl-msg:settingsDialog.tab.language.locale.sl-SI": "🇸🇮 Slovenščina",
  "intl-msg:settingsDialog.tab.language.locale.sv-SE": "🇸🇪 Svenska",
  "intl-msg:settingsDialog.tab.language.select.placeholder": "Select a language ...",
  "intl-msg:settingsDialog.tab.legalInfo.dataProtection": "Data protection",
  "intl-msg:settingsDialog.tab.legalInfo.headline": "Legal",
  "intl-msg:settingsDialog.tab.legalInfo.imprint": "Imprint",
  "intl-msg:settingsDialog.tab.legalInfo.legal": "Legal",
  "intl-msg:settingsDialog.tab.legalInfo.subTitle": "Imprint, Data protection",
  "intl-msg:settingsDialog.tab.loginAndSecurity.headline": "Login & Security",
  "intl-msg:settingsDialog.tab.loginAndSecurity.mfa.error": "Could not update two-factor authentication settings.",
  "intl-msg:settingsDialog.tab.loginAndSecurity.mfa.help": "What?",
  "intl-msg:settingsDialog.tab.loginAndSecurity.mfa.label": "Two-factor authentication",
  "intl-msg:settingsDialog.tab.loginAndSecurity.mfa.success": "Settings updated",
  "intl-msg:settingsDialog.tab.loginAndSecurity.mfaOptions.disabled": "Two-factor disabled",
  "intl-msg:settingsDialog.tab.loginAndSecurity.mfaOptions.disabled.description": "Login only requires user name and password",
  "intl-msg:settingsDialog.tab.loginAndSecurity.mfaOptions.otp": "Email/SMS verification code",
  "intl-msg:settingsDialog.tab.loginAndSecurity.mfaOptions.otp.description": "At log in, you will receive a code sent to your email or phone number",
  "intl-msg:settingsDialog.tab.loginAndSecurity.subTitle": "Email, Password, 2FA",
  "intl-msg:settingsDialog.tab.newsletter.button.save.label": "Save changes",
  "intl-msg:settingsDialog.tab.newsletter.subscription.negative": "Not subscribed",
  "intl-msg:settingsDialog.tab.newsletter.subscription.positive": "Subscribed",
  "intl-msg:settingsDialog.tab.personalData.button.save.label": "Save changes",
  "intl-msg:settingsDialog.tab.personalData.error.updatePersonalData": "Could not update user data. Please try again later.",
  "intl-msg:settingsDialog.tab.personalData.headline": "Personal info",
  "intl-msg:settingsDialog.tab.personalData.label.firstName": "First name",
  "intl-msg:settingsDialog.tab.personalData.label.lastName": "Surname",
  "intl-msg:settingsDialog.tab.personalData.label.password": "Password",
  "intl-msg:settingsDialog.tab.personalData.label.passwordReset": "Change Password",
  "intl-msg:settingsDialog.tab.personalData.label.userName": "User name",
  "intl-msg:settingsDialog.tab.personalData.placeholder.firstName": "First name",
  "intl-msg:settingsDialog.tab.personalData.placeholder.lastName": "Surname",
  "intl-msg:settingsDialog.tab.personalData.subTitle": "Name, Language",
  "intl-msg:settingsDialog.title": "My profile & settings"
}